<script setup lang="ts">
import { AxialForm } from '@common';
import { useSoilTemperaturePeriod } from '../..';

const { form, valid, applySoilTemperaturePeriod } = useSoilTemperaturePeriod();
</script>

<template>
  <v-card
    class="pa-4 ma-4"
    elevation="4">
    <axial-form :form="form.element" />
    <div class="d-flex justify-center">
      <v-btn
        class="mt-2"
        color="primary"
        :disabled="!valid"
        @click="applySoilTemperaturePeriod()">
        {{ $t('statistics.wizard.label.applyTemperatures') }}
      </v-btn>
    </div>
  </v-card>
</template>
